// extracted by mini-css-extract-plugin
var _1 = "RequestMultiValuedListItem-moduleRequestMultiValuedListItem__H2CdW MultiValuedListItem-moduleMultiValuedListItem__IhIDF";
var _2 = "RequestMultiValuedListItem-moduletag__J9p7D RequestTag-moduleRequestTag__INw7t Tag-moduleTag__FLr9H";
export { _1 as "RequestMultiValuedListItem", _2 as "tag" }
